import PointsTipVue from './Index.vue'
// 定义插件对象
const PointsTip = {}
// vue的install方法，用于定义vue插件
PointsTip.install = function (Vue) {
  const instance = Vue.extend(PointsTipVue)
  let currentComp
  let compEl
  const initInstance = () => {
    // 实例化vue实例
    currentComp = new instance()
    compEl = currentComp.$mount().$el
    document.body.appendChild(compEl)
  }
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$PointsTip = (count = 0, text) => {
    if (text && count) {
      initInstance()
      text && (currentComp.$props.text = text)
      currentComp.$props.count = count
      return currentComp
    }
  }
}
export default PointsTip
